import axios from "axios"
import config from "../vue.config"

const api = {}
const baseUrl = config.publicPath

api.getCenters = function() {
  return axios.get("/locations/locations.json")
}

api.getPolicy = function(centerId) {
  if (centerId) {
    return axios.get(`${baseUrl}policies/policies-${centerId}.json`).catch(() => {
      return axios.get(`${baseUrl}policies/default.json`)
    })
  } else {
    return axios.get(`${baseUrl}policies/default.json`)
  }
}

api.submitForm = function(centerId, form, signature, policy) {
  const data = {
    centerId,
    info: [],
    parents: form.parents,
    referredBy: form.referredBy,
    signature,
    policy,
    answer: "",
    key: "iXXC2g8nElRX3OcebXrDxMfchWKeHpE806ueRzfwhWxxhkRaix63HLrX8KaHvsEY",
    dateSubmitted: new Date(),
  }

  for (var student of form.students) {
    const info = Object.assign({}, student)
    info.address = form.address.address1
    info.city = form.address.city
    info.state = form.address.state
    info.zip = form.address.zip
    data.info.push(info)
  }
  const url = centerId.indexOf("practice") >= 0 ? "https://app.practice.bicedu.com/api/registration" : "https://app.bicedu.com/api/registration"

  return axios.post(url, data)
}

export default api
